import axios from 'axios';

function baseUrl(environment) {
    return process.env.VUE_APP_API_URL + '/' + environment;
}

function baseQuestionUrl(environment) {
    return baseUrl(environment) + '/question';
}

export async function fetchFirstQuestion (environment) {
    const { data } = await axios.get(baseQuestionUrl(environment) + '/first');

    return data;
}

export const fetchQuestions = (questions, environment) => {
    return axios.post(baseQuestionUrl(environment) + '/get', {
        ids: questions
    });
}

export async function fetchProducts (stepsTaken, environment) {
    return axios.post(baseUrl(environment) + '/products/get', {
        answers: stepsTaken
    });
}
